import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

export const CalendarIcon = CalendarTodayIcon;
